export default "__VITE_ASSET__GXa5YMb1__"